import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { useCallback, useState } from 'react';
import { debounce } from 'lodash';
import ct from 'countries-and-timezones';
// import axios from 'axios';
import styles from './style.scss';

// import { WIX_INSTANCE_PARAMS } from '../../actions/component_actions';
// import { Form } from 'react-bootstrap';

export const FormPhoneInput = ({ defaultValue, onChange, timezone, isInvalid }) => {
  const [value, setValue] = useState(defaultValue);
  const { countries } = ct.getTimezone(timezone);
  const country = countries[0] || 'us';

  const createTarget = (number) => ({
    target: {
      value: number,
    },
  });
  const handler = async (number = '') => {
    const numberWithPlus = number.startsWith('+') ? number : `+${number}`;
    setValue(numberWithPlus);
    onChange(createTarget(numberWithPlus));
    // try {
    //   const url = `${process.env.EVENTVIEWER_SERVER}/api/v1/phone-validate${WIX_INSTANCE_PARAMS}`;
    //   const numberWithPlus = number.startsWith('+') ? number : `+${number}`;
    //   setValue(numberWithPlus);
    //   await axios.post(url, { phone: numberWithPlus }, { withCredentials: true });
    //   onChange(createTarget(numberWithPlus));
    // } catch (e) {
    //   onChange(createTarget(''));
    // }
  };

  const debouncedChangeHandler = useCallback(debounce(handler, 1000), []);

  return (
    <>
      <PhoneInput country={country.toLowerCase()} value={value} enableSearch onChange={debouncedChangeHandler} />
      <fieldset>{/* <Form.Check type="checkbox" label="Receive Ticket Updates" name="checkbox-option-ticket-update" /> */}</fieldset>
      {isInvalid && <div className={styles.invalid}>Invalid phone number</div>}
    </>
  );
};
